/** Slow editorial marquee (CSS-based, respects reduced motion). */
export function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <div className="mv-marquee-track">
        {doubled.map((item, i) => (
          <span key={i} className="mx-10 inline-flex items-center text-2xl md:text-3xl font-heading font-light tracking-[0.15em] uppercase text-lightgray">
            {item}
            <span className="mx-10 h-1.5 w-1.5 rounded-full bg-accent2 inline-block align-middle" />
          </span>
        ))}
      </div>
    </div>
  );
}
